<template>
  <div class="container">
    <div class="card">
      <div class="title"></div>

      <form @submit.prevent="submit">
        <div class="input">
          <label>Titel</label>
          <input ref="title" v-model="title" type="text" />
        </div>

        <br />

        <div class="input">
          <label>Opslag</label>
          <textarea ref="content" v-model="content" />
        </div>

        <br />

        <div class="action">
          <button ref="btn" @click="create">Gem</button>
        </div>
      </form>

      <div class="link"></div>
    </div>
  </div>
</template>

<script>
import router from "../../router";

export default {
  data() {
    return {
      title: null,
      content: null,
      error: "",
    };
  },
  methods: {
    create() {
      if (!this.title) {
        this.$refs["title"].placeholder = "Angiv titel";
        return;
      }
      if (!this.content) {
        this.$refs["content"].placeholder = "Beskriv din igle";
        return;
      }

      this.$refs["title"].disabled = true;
      this.$refs["content"].disabled = true;
      this.$refs["btn"].disabled = true;

      let post = {
        postTitle: this.title,
        postBody: this.content,
      };

      this.$store
        .dispatch("api/post", { url: "/1/post", data: { post } })
        .then((resp) => router.push("/igler/post/" + resp.data))
        .catch(() => {
          this.$refs["title"].value = "";
          this.$refs["content"].value = "";

          this.$refs["title"].placeholder = "Iglen døde...";
          this.$refs["content"].placeholder = "";

          this.$refs["title"].disabled = false;
          this.$refs["content"].disabled = false;
          this.$refs["btn"].disabled = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 30px;

  .card {
    width: 500px;
    max-width: 500px;
    min-height: 450px;
    background-color: #ffffff;
    box-shadow: 0 0 15px #999999;
    border-radius: 12px;
    padding: 40px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .input {
      display: flex;
      flex-direction: column;

      label {
        margin: 10px 0;
        font-weight: 600;
      }

      input {
        margin-bottom: 10px;
        padding: 10px 5px;
        font-size: 18px;

        &::placeholder {
          color: #d05366;
          opacity: 1;
          font-size: 18px;
          font-weight: 600;
        }
        &:-ms-input-placeholder {
          color: #d05366;
          opacity: 1;
          font-size: 18px;
          font-weight: 600;
        }
        &::-ms-input-placeholder {
          color: #d05366;
          opacity: 1;
          font-size: 18px;
          font-weight: 600;
        }
      }

      textarea {
        max-width: 100%;
      }
    }

    .action {
      button {
        border: none;
        font-size: 18px;
        padding: 12px 25px;
        font-weight: 600;
        box-shadow: 0 0 5px #999999;
        color: #ffffff;
        cursor: pointer;
        background-color: #d05366;

        transition: box-shadow 0.2s;

        &:hover {
          box-shadow: 0 0 10px #333333;
        }
      }
    }

    .link {
      width: 100%;
      text-align: center;

      label {
        cursor: pointer;
      }
    }
  }
}

label {
  font-size: 18px;
}

@media only screen and (max-width: 600px) {
  .card {
    width: calc(100% - 15px);
    margin: 15px;
  }
}
</style>
